import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MoovTokenErrorResponse, IMoovTokenSuccessResponse} from '../../interfaces';
import { HttpErrorResponse } from '@angular/common/http';
 
@Injectable({
  providedIn: 'root'
})
export abstract class AbstractAuthorizationService {

  abstract resetMoovToken(): void;

  abstract getMoovToken(userMail: string, password: string): Observable<HttpResponse<IMoovTokenSuccessResponse>>;

  abstract updateLoggedInUserToken(): Observable<void>;
  
  abstract saveUserDetailsLocally(token: string): void;

  abstract getTokenUrl(): string;

  abstract getValidateTokenlessRegistrationForCustomerUrl(): string;

  abstract getTokenLoginUrl(): string;

  abstract getRegisterUserFromTokenUrl(): string;

  abstract isTokenExpired(token: string): boolean ;

  abstract isExpireDatePass(expiredDate: number): boolean;

  abstract isSessionExpiredRequestError(err: MoovTokenErrorResponse): boolean;

  abstract isUnauthorizedError(err: MoovTokenErrorResponse): boolean;

  abstract isMoovTokenSessionExpiredRequestError(err: HttpErrorResponse): boolean;

  abstract getReturnUrl(removeReturnUrl: boolean): string;  

  abstract tokenLogin(tokenBody: string): Observable<boolean>;

  abstract registerUserFromToken(tokenBody: string, customerId: string, firstName: string, lastName: string, mailAddress: string, userInputCompany: string, userInputRole: string, locale: string, gender: number, inMgmtPos: boolean, isApproveShareMotivations: boolean, password: string): Observable<HttpResponse<IMoovTokenSuccessResponse>>;

  abstract validateTokenlessRegistrationForCustomer(customerId: string): Observable<boolean>;
}
